import { create } from 'zustand';
import { PERMISSION_STATE } from '../constants/Notification';

export const useChatStore = create((set) => ({
    sidebarStateChangeKey: 0,
    isBlockModalOpen: false,
    hasRecentUsers: false,
    isEditModalOpen: false,
    messageToEdit: null,
    isSidebarOpen: true,
    deletingChannel: false,
    mode: "recent",
    activeChannel: null,
    loading: true,
    error: false,
    loadingMore: false,
    hasMore: true,
    chatError: null,
    isDeleteModalOpen: false,
    messageToDelete: null,
    isModalOpen: false,
    sidebarLoading: true,
    userDetails: { primary: null, secondary: null },
    userToBlock: null,
    userIds: { primary: null, secondary: null },
    primaryUserId: null,
    secondaryUserId: null,
    isDeletingMessage: false,
    chatClient: null,
    setChatClient: (client) => set({ chatClient: client }),
    setPrimaryUserId: (id) => set({ primaryUserId: id }),
    setSecondaryUserId: (id) => set({ secondaryUserId: id }), 
    // Setters
    setSidebarStateChangeKey: (updater) =>
      set((state) => ({
          sidebarStateChangeKey:
            typeof updater === "function"
              ? updater(state.sidebarStateChangeKey || 0)
              : updater,
      })),
    setIsBlockModalOpen: (v) => set({ isBlockModalOpen: v }),
    setHasRecentUsers: (v) => set({ hasRecentUsers: v }),
    setIsEditModalOpen: (v) => set({ isEditModalOpen: v }),
    setMessageToEdit: (v) => set({ messageToEdit: v }),
    setIsSidebarOpen: (updater) => {
        set((state) => ({
            isSidebarOpen:
              typeof updater === "function" ? updater(state.isSidebarOpen) : updater,
        }));
    },
    setDeletingChannel: (v) => set({ deletingChannel: v }),
    setMode: (v) => set({ mode: v }),
    setActiveChannel: (v) => set({ activeChannel: v }),
    setLoading: (v) => set({ loading: v }),
    setError: (v) => set({ error: v }),
    setLoadingMore: (v) => set({ loadingMore: v }),
    setHasMore: (v) => set({ hasMore: v }),
    setChatError: (v) => set({ chatError: v }),




    setIsDeleteModalOpen: (v) => set({ isDeleteModalOpen: v }),
    setMessageToDelete: (v) => set({ messageToDelete: v }),
    setIsModalOpen: (v) => set({ isModalOpen: v }),
    setSidebarLoading: (v) => set({ sidebarLoading: v }),
    setUserDetails: (v) => set({ userDetails: v }),
    setUserToBlock: (v) => set({ userToBlock: v }),
    setUserIds: (v) => set({ userIds: v }),
    setIsDeletingMessage: (v) => set({ isDeletingMessage: v }),
    // New state for refreshing the banner
    refreshBanner: false,
    toggleRefreshBanner: () => set((state) => ({ refreshBanner: !state.refreshBanner })),




    // New states for FCMNotificationBanner
    permission: typeof Notification !== "undefined" ? Notification.permission : PERMISSION_STATE.DEFAULT,
    setPermission: (value) => set({ permission: value }),

    fcmloading: false,
    setFcmLoading: (value) => set({ fcmloading: value }),

    closed: false,
    setClosed: (value) => set({ closed: value }),
}));
